import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../../lib/route-guard.js';
import { emptyEventWizardFormValues } from '../../../modules/events/wizard/empty-event-wizard-form-values.js';
import { EventWizard } from '../../../modules/events/wizard/event-wizard.js';

export const Route = createFileRoute('/events/templates/new')({
  component: NewTemplatePage,
});

// eslint-disable-next-line react-refresh/only-export-components -- TanStack Router requires co-exporting Route with the component
function NewTemplatePage() {
  return (
    <RouteGuard route="/events/templates">
      <EventWizard defaultValues={emptyEventWizardFormValues('template')} />
    </RouteGuard>
  );
}
